const triangleContent = [
  { id: 1, title: 'MAXIMUM POTENTIAL', content: 'We help you discover the full potential of your investment, which enables you to make good decisions, be competitive and keep your business profitable.' },
  { id: 2, title: 'HIGH STANDARDS', content: 'We rely on proven data-driven methodology and approach each project individually. We take security and confidentiality very seriously.' },
  { id: 3, title: 'TRANSPARENT COOPERATION', content: 'Hand in hand with your team, we look for digital opportunities by honestly assessing the risk. We analyze projects in detail and accurately report each aspect.' },
];

export default triangleContent;
